enum Label {
  SaveAndVerify = 'Save & Verify',
  Save = 'Save',
  Verify = 'Verify',
  Cancel = 'Cancel',
  SelectAll = 'Select All',
  YesTurnOff = 'Yes, turn off',
  NoKeepOn = 'No, keep on',
  SubmitRequest = 'Submit request',
  Submit = 'Submit',
  Attach = 'Attach',
  Pending = 'Pending',
  PendingUpto = 'Pending (Up to 24h)',
  Archive = 'Archive',
  Accept = 'Accept',
  Reject = 'Reject',
  CredentialingStatus = 'Credentialing Status',
  UNKNOWN = 'UNKNOWN',
  CvoStatus = 'CVO Status',
  Add = 'Add',
  Owner = 'Owner',
  ApprovalStatus = 'Approval Status',
  Export = 'Export',
  UnableToVerify = 'Unable to Verify',
  Expired = 'Expired',
  DisciplinaryAction = 'Disciplinary Action',
  ExpiredAndDispAction = 'Expired & Disciplinary Action',
  MatchFound = 'Match Found',
  ReportFound = 'Report Found',
  Failed = 'Failed',
  NotRequiredLabel = 'N/A',
  SaveAndImport = 'Save & Import',
  SaveAndReImport = 'Save & Re-import',
  WorkHistory = 'Work History',
  Training = 'Training',
  LiabilityInsurance = 'Liability Insurance',
  GapInEmployment = 'Gap in Employment',
  Activate = 'Activate',
  ImportCaqhProfile = 'Import CAQH Profile',
  AddCaqh = 'Add CAQH',
  AddCaqhInfo = 'Add CAQH Info',
  Dismiss = 'Dismiss',
  MergeProfile = 'Merge Profile',
  Review = 'Review',
  DontAdd = `Don't add`,
  Reviewed = 'Reviewed',
  UnknownMergeType = 'Unknown Merge Type',
  CompleteMerge = 'Complete Merge',
  Confirm = 'Confirm',
  ChangeTo = 'Change to',
  AcceptAll = 'Accept All',
  IgnoreAll = 'Ignore All',
  Updated = 'Updated',
  Done = 'Done',
  UnknownLicenseType = 'Unknown License Type',
  Resolved = 'Resolved',
  Resume = 'Resume',
  RetryImport = 'Retry Import',
  CaqhMerge = 'CAQH Merge',
  CancelMerge = 'Cancel Merge',
  SaveAndClose = 'Save & Close',
  Refresh = 'Refresh',
  ImportFailed = 'Import Failed',
  Ignore = 'Ignore',
  UnknownLicenseState = 'Unknown License State',
  BasicInformation = 'Basic Information',
  UnknownLicenseTypeAndState = 'Unknown License Type & State',
  Edit = 'Edit',
  MergeReady = 'Merge Ready',
  UnknownBoardCertType = 'Unknown Board Certification Type',
  UnknownInsuranceCoverageType = 'Unknown Insurance Coverage Type',
  UnknownSchoolName = 'Unknown School Name',
  Back = 'Back',
  StartDate = 'Start Date',
  EndDate = 'End Date',
  EffectiveDate = 'Effective Date',
  ExpirationDate = 'Expiration Date',
  Current = 'Current',
  ReviewNow = 'Review now',
  IgnoreThisRecord = 'Ignore this record',
  Close = 'Close',
  VerifiableLabel = 'Verifiable',
  Reset = 'Reset',
  State = 'State',
  PrimaryLicense = 'Primary License',
  LicensePracticingState = 'Provider is currently practicing in this state',
  EducationSchoolCompleted = 'Provider completed their graduate education at this school',
  CurrentEmployer = 'Current employer',
  SelfInsured = 'Self Insured',
  PrimarySpecialty = 'Primary specialty',
  DEA = 'DEA',
  ConfirmChanges = 'Confirm Changes',
  Added = 'Added',
  Edited = 'Edited',
  CaqhLogin = 'CAQH Login',
  License = 'License',
  BoardCertification = 'Board Certification',
  Certificate = 'Certificate',
  DeaRegistration = 'DEA Registration',
  Note = 'Note',
  Monitor = 'Monitor',
  Alert = 'Alert',
  File = 'File',
  EventLog = 'Event Log',
  DownloadLog = 'Download Log',
  Group = 'Group',
  Provider = 'Provider',
  Payer = 'Payer',
  PayerPlan = 'Payer Plan',
  ProviderEnrollment = 'Provider Enrollment',
  OrgSettings = 'Org Settings',
  ProviderProfileImport = 'Provider profile import',
  CredentialingRequest = 'Credentialing Request',
  Schema = 'Schema',
  ProfileMerge = 'Profile Merge',
  VerificationMetadata = 'Verification metadata',
  LicenseWalletCopy = 'License wallet copy',
  DownloadDocuments = 'Download documents',
  LicenseVerificationReport = 'License verification report',
  Download = 'Download',
  HideDetails = 'Hide details',
  Details = 'Details',
  ViewResult = 'View Result',
  DateRange = 'Date Range',
  NoErrorMessage = 'No error message',
  FilterByThisItem = 'Filter by this item',
  DateVerified = 'Date Verified',
  LicenseCurrentlyPracticing = 'Practicing in this state',
  PrescriptiveAuthorityRequiredMet = 'Prescriptive authority met',
  PrescriptiveAuthorityRequiredNotMet = 'Prescriptive authority not met',
  Restricted = 'Restricted',
  NotRestricted = 'Not Restricted',
  NotApproved = 'Not Approved',
  Approved = 'Approved',
  ProviderSanctionReport = 'Provider S&E Report',
  DownloadReport = 'Download Report',
  Reports = 'Reports',
  MonthlySEMonitoring = 'Monthly S&E Monitoring',
  ExportLicenses = 'Export Licenses',
  SanctionsMonitoringReport = 'Sanctions and Exclusions monitoring report',
  DocumentNotAvailable = 'Document not available',
  DocumentDownloadInfoNotAvailable = 'Document download info not available',
  GoToDocumentLocation = 'Go to document location',
  UnknownFile = 'Unknown File',
  YesVerify = 'Yes, verify',
  Overdue = 'Overdue',
  Apply = 'Apply',
  GoBack = 'Go Back',
  ExpirableCredentials = 'Expirable Credentials',
  Enrollments = 'Enrollments',
  PleaseSelect = 'Please Select',
  Roster = 'Roster',
  Logout = 'Logout',
  ExternalProfiles = 'External Profiles',
  ImportCaqhOrAma = 'Import CAQH or AMA',
  AlreadyAdded = 'Already Added',
  ImportRecordsFromAMA = 'Import Records from AMA',
  Import = 'Import',
  ImportAmaProfile = 'Import AMA Profile',
  AMA = 'AMA',
  VerifyEducation = 'Verify Education',
  AddTraining = 'Add Training',
  Continue = 'Continue',
  ImportFromAma = 'Import From AMA',
  AmaMergeReady = 'AMA Merge Ready',
  MergeRecord = 'Merge Records',
  ImportAmaRecords = 'Importing AMA records',
  AmaMerge = 'AMA Merge',
  MergeExistingRecords = 'Merge with existing records',
  NewRecordsAdded = 'New records to be added',
  MergingAma = 'Merging AMA',
  AmericanMedicalAssociation = 'American Medical Association',
  Found = 'Found',
  NCCPAID = 'NCCPA ID',
  Education = 'Education',
  FailedVerifications = 'Failed Verifications',
  Manage = 'Manage',
  Monitoring = 'Monitoring',
  MonitoredActiveProviders = 'Monitored active providers',
  Next = 'Next',
  Enable = 'Enable',
  Dashboard = 'Dashboard',
  Providers = 'Providers',
  FirstName = 'First Name',
  LastName = 'Last Name',
  NPI = 'NPI',
  ProviderType = 'Provider Type',
  Status = 'Status',
  EnableMonitoring = 'Enable Monitoring',
  DownloadResults = 'Download results',
  EnablementHistory = 'Enablement History',
  SanctionMonitoringDashboard = 'S&E Monitoring Dashboard',
  Dataset = 'Dataset',
  MedicaidEnrollment = 'Medicaid Enrollment',
  NeedsReview = 'Needs Review',
  SanctionMonitoring = 'S&E Monitoring',
  Country = 'Country',
  AddAll = 'Add All',
  RaceAndEthnicity = 'Race and Ethnicity',
  NotFound = 'Not Found',
  TurnOffMonitoring = 'Turn off monitoring',
  AliasName = 'Alias Name',
  SanctionsAndExclusions = 'Sanctions & Exclusions',
  NotActive = 'Not Active',
  Active = 'Active',
  AddFile = 'Add File',
  Organization = 'Organization',
  DbaName = 'DBA Name',
  YesRemove = 'Yes, remove',
  Specialty = 'Specialty',
  Inactive = 'Inactive',
  Deleting = 'Deleting',
  Renaming = 'Renaming',
  Practicing = 'Practicing',
  NotPracticing = 'Not Practicing',
  Default = 'Default',
  Remove = 'Remove'
}

export default Label;
